<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Onttrekkingen van kapitaal gedurende het boekjaar
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Van onttrrekkingen, ook wel 'terugbetaling van kapitaal' genoemd, kan sprake zijn bij:</p>
                <ul class="bullet-list">
                    <li>winstuitdelingen.</li>
                    <li>terugbetaling van gestort kapitaal op aandelen.</li>
                    <li>inkoop van eigen aandelen.</li>
                    <li>liquidatie-uitkeringen.</li>
                    <li>terugbetaling van agio.</li>
                </ul>
                <p>Vermeld hier ook de mutaties op het ondernemingsvermogen als gevolg van een tussentijdse voeging of
                    ontvoeging.</p>
                <p>Als de terugbetaling van kapitaal geheel of gedeeltelijk als een dividenduitkering wordt beschouwd,
                    vermeldt u die in de specificatie 'Dividenduitkeringen'.</p>

                <b>Winstuitdeling</b>
                <p>
                    Als de terugbetaling van kapitaal geheel of gedeeltelijk als een dividenduitkering wordt beschouwd,
                    vermeldt u die in de specificatie 'Dividenduitkeringen'.
                    <br/> <br/>
                    Voor de vennootschap die de uitkering doet, heeft dit geen consequenties voor de
                    vennootschapsbelasting. Wel is het mogelijk dat er dividendbelasting op de uitkering moet worden
                    ingehouden. Voor de heffing van dividendbelasting wordt de terugbetaling van kapitaal beschouwd als
                    een uitkering van winstreserves.
                </p>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Stortingen van kapitaal gedurende het boekjaar
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Er zijn 2 soorten kapitaalstortingen:</p>
                <ul>
                    <li>formele kapitaalstortingen, bijvoorbeeld uitbreiding van het aandelenkapitaal.</li>
                    <li>informele kapitaalstortingen.</li>
                </ul>
                <p>Vermeld hier ook de mutaties op het ondernemingsvermogen als gevolg van een tussentijdse voeging of
                    ontvoeging.</p>
                <p>Een kapitaalstorting kan zowel in geld als in natura plaatsvinden. Voor de waardering van een
                    kapitaalstorting in natura geldt de waarde op het moment van de storting.</p>

                <b>Informeel kapitaal</b>
                <p>Van informeel kapitaal kan sprake zijn als de vennootschap door de aandeelhouder(s) is bevoordeeld,
                    zonder dat een storting op aandelen heeft plaatsgevonden. De waarde van deze bevoordeling geeft u
                    aan op de balans, onder 'Ondernemingsvermogen'.</p>
                <div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <p><u>Voorbeeld</u></p>
                    <p>De aandeelhouder verkoopt onroerend goed aan de vennootschap voor € 500.000, terwijl de
                        werkelijke waarde € 800.000 is. <br/>De vennootschap wordt bevoordeeld voor € 300.000.</p>
                </div>

                <br/>
                <p>Als informele kapitaalstorting wordt ook aangemerkt de kapitaalstorting voor toegekende
                    werknemersopties.</p>


            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Vennootschapsbelasting
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Vennootschapsbelasting is niet aftrekbaar van de winst. Daarom moet je deze toevoegen aan de
                    winst.</p>
                <p>Het gaat om:</p>
                <ul>
                    <li>de vennootschapsbelasting over dit boekjaar die door betaling of passivering ten laste van het
                        vermogen is gekomen.
                    </li>
                    <li>de vennootschapsbelasting over dit boekjaar die door ontvangst of activering ten gunste van het
                        vermogen is gekomen.
                    </li>
                    <li>de vennootschapsbelasting die op vorige jaren betrekking heeft en die door betaling of
                        passivering ten laste van het vermogen is gekomen.
                    </li>
                    <li>de vennootschapsbelasting die op vorige jaren betrekking heeft en die door ontvangst of
                        activering ten gunste van het vermogen is gekomen.
                    </li>
                </ul>
                <p>
                    Ontvangen vennootschapsbelasting behoort niet tot de fiscale winst. Is er per saldo een bedrag
                    ontvangen of geactiveerd? Zet dan een minteken voor het bedrag.
                </p>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingT4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Buitenlandse winstbelasting
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="headingT4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Buitenlandse winstbelasting is niet aftrekbaar van de winst. Daarom moet je deze toevoegen aan de
                    winst. Het gaat om de buitenlandse winstbelasting die in dit boekjaar ten gunste of ten laste van
                    het vermogen is gekomen.
                    <br/><br/>
                    Het gaat ook om buitenlandse winstbelasting over vorige boekjaren, voor zover deze in dit boekjaar
                    ten gunste of ten laste van het vermogen is gekomen.

                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Andere uitdelingen van winst
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Vermeld hier bijvoorbeeld:</p>
                <ul>
                    <li>de niet-aftrekbare winstuitdelingen door coöperaties of verenigingen op coöperatieve
                        grondslag.
                    </li>
                    <li>het bedrag van de uitgekeerde dividenden waarop de vennootschap geen dividendbelasting hebt
                        ingehouden.
                    </li>
                    <li>dividend dat door een fiscaal gevoegde dochtermaatschappij betaalbaar is gesteld aan andere
                        aandeelhouders dan de moedermaatschappij.
                    </li>
                    <li>niet-aftrekbare beloningen en vergoedingen.</li>
                </ul>
                <p>Van een vermomde winstuitdeling of vermomd dividend is sprake als een vennootschap haar
                    aandeelhouders 'via een omweg' bevoordeelt.</p>

                <b>Niet-aftrekbare belingen en vergoedingen</b>
                <p>Hieronder vallen:</p>
                <ul>
                    <li>het niet-aftrekbaar deel beloningen van commissarissen.
                    </li>
                    <li>het niet-aftrekbaar deel tantièmes van bestuurders en overig personeel.
                    </li>
                    <li>het niet-aftrekbaar deel vergoedingen voor kapitaalverstrekking.</li>
                </ul>

                <b>Beloningen van commissarissen</b>
                <p>Commissarisbeloningen zijn alleen geheel aftrekbaar als ze zijn toegekend voor een van de volgende
                    taken:</p>
                <ul>
                    <li>de toezichthoudende taak voor niet-aandeelhouders.</li>
                    <li>het bijkomstig uitoefenen van de bestuurstaak, bijvoorbeeld als adviseur.</li>
                </ul>
                <p>Als de beloning is toegekend aan een commissaris die ook aanmerkelijk-belanghouder is in de
                    vennootschap, dan geldt een beperking. In dat geval is de beloning tot € 1.815 aftrekbaar. Bedraagt
                    de beloning meer dan € 1.815, dan is de helft van de beloning aftrekbaar, met een minimum van €
                    1.815 en met een maximum van € 9.076.</p>

                <b>Tantièmes van bestuurders en overig personeel</b>
                <p>Vermeld het niet-aftrekbare deel van de tantièmes van bestuurders en overig personeel. Tantièmes zijn
                    alleen aftrekbaar als ze zijn toegekend voor arbeid die in de onderneming is verricht.</p>

                <b>Vergoedingen voor kapitaalverstrekking</b>
                <p>Het gaat om vergoedingen voor kapitaalverstrekking aan oprichters, aandeelhouders, leden of
                    deelgerechtigden. Het gaat om:</p>
                <ul>
                    <li>rente op inleggelden en ledenrekeningen van een coöperatie of van een vereniging op coöperatieve
                        grondslag. Deze inleggelden en ledenrekeningen behoren tot het eigen vermogen van de coöperatie
                        of vereniging.
                    </li>
                    <li>rente op aandelen in een waarborgfonds en alle renten die het karakter hebben van een vergoeding
                        voor kapitaalverstrekking. Of er sprake is van een kapitaalverstrekking of van een lening, hangt
                        af van de feitelijke omstandigheden.
                    </li>
                </ul>
                <p>Onder 'Niet aftrekbaar deel vergoedingen voor kapitaalverstrekking'wordt ook verstaan de
                    niet-aftrekbare rente op hybride leningen.</p>


            </div>
        </div>
    </div>

</div>
